const buttonFormMaintenance = {
  cancel: 'CANCELAR MANUTENCIÓN',
  send_to_maintenance: 'ENVIAR PARA MANUTENCIÓN',
  done: 'CONCLUIR MANUTENCIÓN',
  send_back_to_maintenance: 'RETORNAR PARA MANUTENCIÓN'
};

export default buttonFormMaintenance;